// Merges only newly-discovered legal entities into the portfolio (unchanged logic
// from before, minus the projects half). Entities have no equivalent "can't be saved"
// trap the way empty-cost-center projects do, so they're safe to auto-merge.
export const mergeDiscoveredEntities = (portfolio, discovered) => {
  const existingEntityIds = new Set(portfolio.legalEntities.map((item) => item.erpCompanyId));
  const newEntities = (discovered?.legalEntities || [])
    .filter((item) => !existingEntityIds.has(item.erpCompanyId))
    .map((item) => ({
      erpCompanyId: item.erpCompanyId,
      name: item.name,
      poolingGroupId: `entity-${item.erpCompanyId}`,
      state: "active",
    }));
  return { ...portfolio, legalEntities: [...portfolio.legalEntities, ...newEntities] };
};

// Computed fresh from current state every time (never stored) — a discovered project
// disappears from this list once the admin adds it (or once it's already present),
// and a project whose legal entity isn't actually in the portfolio never appears here.
// Sienge cost centers aren't scoped to a project, so we can't populate costCenters
// automatically — that's why this is a "pick one to add" list, not an auto-merge.
export const availableDiscoveredProjects = (portfolio, discovered) => {
  const knownEntityIds = new Set(portfolio.legalEntities.map((item) => item.erpCompanyId));
  const existingProjectIds = new Set(portfolio.projects.map((item) => item.erpProjectId));
  return (discovered?.projects || [])
    .filter((item) => (
      !existingProjectIds.has(item.erpProjectId) && knownEntityIds.has(item.erpCompanyId)
    ));
};
